export const SET_SETLOGGEDINUSER_DETAILS = 'SET_SETLOGGEDINUSER_DETAILS';
export const LOG_USER_IN = 'LOG_USER_IN';
export const LOG_USER_OUT = 'LOG_USER_OUT';

export const setLoggedInUserDetails = userDetails => ({
    type: SET_SETLOGGEDINUSER_DETAILS,
    payload: userDetails,
});


export const logUserIn = userDetails => ({
    type: LOG_USER_IN,
    payload: userDetails,
});

export const logUserOut = () => ({
    type: LOG_USER_OUT
});